import * as React from 'react';
import { UitkCardContent, UitkCardTextSegment } from 'uitk-react-cards';
import { PwaHsrPropertyDestinationRefinement } from 'src/common/__generated__/api';
import { DestinationRefinementImageAttribution } from './destination-refinement-image-attribution';
import { classNames } from 'uitk-react-utils';

export interface DestinationRefinementCardContentProps {
  name?: string;
  description?: string;
  affinities?: string[];
  attribution: PwaHsrPropertyDestinationRefinement.Attribution;
  showAffinities?: boolean;
  showDescription?: boolean;
}

export const DestinationRefinementCardContent: React.FunctionComponent<DestinationRefinementCardContentProps> = ({
  name,
  description,
  affinities,
  showDescription,
  showAffinities,
  attribution
}) => {
  const showName = !showAffinities && !showDescription;
  const gridClasses = classNames('uitk-grid', { 'all-t-padding-three all-b-padding-three': !showDescription });
  const nameClasses = classNames('uitk-type-300 uitk-type-bold', {
    'uitk-flex uitk-flex-align-items-center': showName
  });

  return (
    <UitkCardContent>
      <UitkCardTextSegment className="uitk-flex uitk-flex-column white-space-normal">
        <div className={gridClasses}>
          {showName && (
            <div className={nameClasses} data-stid="destination-refinement-name">
              {name}
            </div>
          )}
          {showAffinities && (
            <div className="uitk-cell">
              <span className={nameClasses} data-stid="destination-refinement-name">
                {name}
              </span>
              {affinities && (
                <p className="all-t-margin-half uitk-type-200 pwa-theme--grey-700" data-stid="destination-refinement-affinities">
                  {affinities.join(', ')}
                </p>
              )}
            </div>
          )}
          {showDescription && (
            <div className="uitk-cell">
              <span className={nameClasses} data-stid="destination-refinement-name">
                {name}
              </span>
              {description && (
                <p className="all-t-margin-one uitk-type-200 pwa-theme--grey-700" data-stid="destination-refinement-description">
                  {description}
                </p>
              )}
            </div>
          )}
          {attribution && <DestinationRefinementImageAttribution attribution={attribution} />}
        </div>
      </UitkCardTextSegment>
    </UitkCardContent>
  );
};
